(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('MegafonFreeNumbersService', MegafonFreeNumbersService);

    MegafonFreeNumbersService.$inject = ['$resource'];

    function MegafonFreeNumbersService ($resource) {
        var resourceUrl =  'api/pbx/megafon';

        return $resource(resourceUrl, {}, {
            'getfree': {
                method: 'GET',
                url: 'api/pbx/megafon/getfree',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                },
                isObject: true
            },
            'getfreeCsv': {
                method: 'GET',
                url: 'api/pbx/megafon/getfree-csv'
            },
            'setLockTime': {
                method:'POST',
                url: 'api/pbx/megafon/set-locktime'
            },
            'moveToLocked': {
                method:'POST',
                url: 'api/pbx/megafon/move-to-locked'
            },
            'moveToSim': {
                method:'POST',
                url: 'api/pbx/megafon/move-to-sim'
            }
        });
    }
})();
